import React from 'react';
import {
    useReactTable,
    getCoreRowModel,
    getPaginationRowModel,
    flexRender
} from '@tanstack/react-table';
import { formatDate } from '../Utils/Utils';
import { Header } from '@carbon/react';

export const Ordertable = ({ data, navigation, orderid, laststatus }) => {
    const columns = [
        { header: 'OID', accessorKey: 'id' },
        { header: 'Name', accessorKey: 'fullname' },
        { header: 'Area', accessorKey: 'area' },
        { header: 'Total', accessorKey: 'totalamount' },
        { header: 'Status', accessorKey: 'status' },
        { header: 'Date', accessorKey: 'modified' }
    ];

    const table = useReactTable({
        data: data || [],
        columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        initialState: { pagination: { pageSize: 10 } },
    });

    return (
        <div style={{ overflow: "auto" }}>
            <table style={{ borderBottom: "2px solid darkblue", width: "100%", borderRadius: "5px" }}>
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr style={{
                            height: "5px", color: "darkblue", borderBottom: "1px solid white", borderTop: "1px solid white",
                            cursor: "pointer"
                        }} key={headerGroup.id} >
                            {headerGroup.headers.map(header => (
                                <th style={{ padding: "5px", border: "1px solid white", backgroundColor: "darkgray", height: "50px" }} key={header.id}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {data.includes('no data') ? (
                        <tr style={{ borderBottom: "1px solid white" }}>
                            <td colSpan="5" style={{ padding: "5px", textAlign: "center" }}>
                                No orders found.
                            </td>
                        </tr>
                    ) : (
                        table.getRowModel().rows.map(row => (
                            <tr key={row.id} style={{
                                height: "5px", color: "darkblue", borderBottom: "1px solid white", borderTop: "1px solid white",
                                cursor: "pointer"
                            }} onClick={() => navigation(row.original.id)}>
                                {row.getVisibleCells().map(cell => {
                                    if (cell.column.id === 'modified') {
                                        return (
                                            <td style={{ padding: "5px", border: "1px solid white", backgroundColor: "lightgray", height: "50px" }} key={cell.id}>
                                                {formatDate(new Date(cell.getValue()))}
                                            </td>
                                        );
                                    }

                                    if (cell.column.id === 'status') {
                                        return (
                                            <td style={{ padding: "5px", border: "1px solid white", backgroundColor: "lightgray", height: "50px" }} key={cell.id}>
                                                {laststatus(row.original.id)}
                                            </td>
                                        );
                                    }
                                    if (cell.column.id === 'fullname') {
                                        return (
                                            <td style={{ padding: "5px", border: "1px solid white", backgroundColor: "lightgray", height: "50px" }} key={cell.id}>
                                                {cell.getValue().split(' ')[0]} {/* Display only the first name */}
                                            </td>
                                        );
                                    }

                                    return (
                                        <td style={{ padding: "2px", border: "1px solid white", backgroundColor: "lightgray", height: "50px" }} key={cell.id}>
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    );
                                })}
                            </tr>
                        )
                        ))}
                </tbody>
            </table>
            <div className="pagination-controls" style={{ marginTop: '10px', paddingBottom: "20px", textAlign: "center" }}>
                <button style={{ backgroundColor: "lightgray", border: "1px solid #ccc", cursor: "pointer", width: "100px", borderRadius: "5px" }} onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>Previous</button>
                <span> Page {table.getState().pagination.pageIndex + 1} of {table.getPageCount()} </span>
                <button style={{ backgroundColor: "lightgray", border: "1px solid #ccc", cursor: "pointer", width: "100px", borderRadius: "5px" }} onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>Next</button>
            </div>
        </div>
    );
};

//export default (Customertable);